import styled from '@emotion/styled';
import { IconLetter } from '@kompare/kompare-ui-library';
import { useParams } from 'react-router-dom';
import { i18n, mediaQuery } from 'src/common';
import { useGetGeneralTransferDetails } from 'src/common/api/apollo/queries';
import { BarcodeCard, Button, Flex, Loader, StatusMessage } from 'src/components';
import config from 'src/config';
import { colors, footer, header } from 'src/theme';

const ButtonContainerStyle = styled.div({
  marginTop: 32,
  textAlign: 'center',
});

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,
  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },
  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const CheckoutSuccessGeneralTransferPage = () => {
  const { offerId } = useParams<{ offerId: string }>();
  const { data, loading } = useGetGeneralTransferDetails(1, offerId);

  const navigateToHome = () => {
    window.location.href = config.REACT_APP_KOMPARE_HOME!;
  };

  if (loading) return <Loader page />;

  const Buttons = () => (
    <ButtonContainerStyle>
      <Button btnType="textBlack" onClick={navigateToHome}>
        {i18n.t('pages.checkoutCongratulationsPage.returnToHomeButton')}
      </Button>
    </ButtonContainerStyle>
  );

  return (
    <FlexStyle justify="center" align="center">
      <StatusMessage
        barcode={
          offerId && data ? (
            <BarcodeCard data={data} paymentType="oneTime" />
          ) : undefined
        }
        buttons={<Buttons />}
        icon={<IconLetter color={colors.icon4} />}
        title={i18n.t('pages.checkoutSuccessGeneralTransferPage.title')}
        subtitle={i18n.t('pages.checkoutSuccessGeneralTransferPage.subtitle')}
      />
    </FlexStyle>
  );
};

export default CheckoutSuccessGeneralTransferPage;
